import cx from 'classnames';
import React from 'react';

import { ReactComponent as Check } from 'new/elements/Form/assets/check.svg';
import { StepItem } from 'new/elements/Form/components';
import stepsFormClasses from 'new/elements/Form/components/StepsForm/StepsForm.module.scss';
import Typography from 'new/elements/Typography';
import {
  RegisterCapsuleModalSteps,
  RegisterCapsuleWizardStep,
} from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/RegisterCapsuleModal/context/RegisterCapsuleModalContext';
import rowStyles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/RegisterCapsuleModal/components/RegisterCapsuleStepsRow/RegisterCapsuleStepsRow.module.scss';

type RegisterCapsuleStepsRowProps = {
  activeStep: RegisterCapsuleWizardStep;
  onGoToStep?: (step: RegisterCapsuleWizardStep) => void;
};

export function RegisterCapsuleStepsRow(props: RegisterCapsuleStepsRowProps) {
  const { activeStep, onGoToStep } = props;
  const activePage0 = activeStep - 1;

  return (
    <div className={cx(stepsFormClasses.stepsSection, rowStyles.strip)}>
      <div className={stepsFormClasses.left}>
        <div className={stepsFormClasses.steps}>
          {RegisterCapsuleModalSteps.map((step, index) => {
            const status = StepItem.getStatus(activePage0, index);
            const isStepNavigationDisabled = activeStep === 2 && step.id === 1;
            const onClickStep = () => {
              if (status === 'done' && !isStepNavigationDisabled) {
                onGoToStep?.(step.id);
              }
            };

            return (
              <div
                key={step.id}
                className={cx(
                  stepsFormClasses.stepContainer,
                  stepsFormClasses['stepContainer_' + status],
                  isStepNavigationDisabled && rowStyles.disabledStep,
                )}
              >
                <button
                  type="button"
                  className={stepsFormClasses.step}
                  onClick={onClickStep}
                  disabled={isStepNavigationDisabled}
                >
                  <div className={stepsFormClasses.indexWrapper}>
                    {status === 'done' ? <Check /> : <span>{index + 1}</span>}
                  </div>
                  <Typography>{step.label}</Typography>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
